import React from 'react'
import { Col, Row } from 'reactstrap'

const PathogenEasyAccess = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 pt-md-5 pt-5 py-4'>
            <div className='pb-3'>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh- pb-2'>
                    Easily Accessible Respiratory Pathogen Panel Testing Chicago
                </div>
                <hr className='hr-style my-md-1' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='pb-4'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                The need for Respiratory Pathogen Panel Testing does not start and end with Covid-19. That is why we offer a wide selection of on-site tests that help to improve your healthcare and enhance your comfort. With the latest technological equipment and highly trained staff, our travel testing labs ensure no stone is unturned on the path to reliable healthcare services for you. Because for us, your prime wellness is the priority, but is it yours too?
                </div>
            </div>

            <div className='left-padding5rem1 right-padding5rem1 d-md-none d-lg-block d-flex  '>
                <Row className=''>
                    <Col xs='12' sm='12' md='12' lg='4' className=''>
                    <div className='bg-im h-430' style={{ backgroundImage:'url("pathogen-testing/RPP-Testing-bg1.png")', backgroundSize:'contain', height:'', width:'100%', backgroundRepeat:'no-repeat', paddingLeft:'2rem', paddingTop:'3rem'}}>
                    <div className='pb-3'>
                        <div className='fs-ss-20 text-montserrat fw-700 text-white' style={{ letterSpacing:'0.5px'}}>
                            Viruses:
                        </div>
                    </div>
                        <div className=''>
                            <ul className='fs-ss-15-2 text-montserrat fw-600 text-white ps-4' style={{ letterSpacing:'0.5px'}}>
                                <li className='pb-1'>Adenovirus</li>
                                <li className='pb-1'>Coronavirus 229E </li>
                                <li className='pb-1'>Coronavirus HKU1 </li>
                                <li className='pb-1'>Coronavirus NL63 </li>
                                <li className='pb-1'>Coronavirus OC43 </li>
                                <li className='pb-1'>SARS-COV-2 </li>
                                <li className='pb-1'>Human metapneumovirus</li>
                                <li className='pb-1'>Human Rhinovirus/<br/> Enterovirus </li>
                            </ul>
                        </div>
                    </div>
                    </Col>
                    <Col xs='12' sm='12' md='12' lg='4' className=''>
                        <div className='bg-im h-430' style={{ backgroundImage:'url("pathogen-testing/RPP-Testing-bg1.png")', backgroundSize:'contain', height:'', width:'100%', backgroundRepeat:'no-repeat', paddingLeft:'2rem', paddingTop:'5rem'}}>
                            <ul className='fs-ss-15-2 text-montserrat fw-600 text-white' style={{ letterSpacing:'0.5px'}}>
                                <li className='pb-1'>Influenza A, Including<br/> Subtypes (A/H1, A/H3)</li>
                                <li className='pb-1'>Influenza A/H1-2009</li>
                                <li className='pb-1'>Influenza B</li>
                                <li className='pb-1'>Parainfluenza Virus 1</li>
                                <li className='pb-1'>Parainfluenza Virus 2</li>
                                <li className='pb-1'>Parainfluenza Virus 3</li>
                                <li className='pb-1'>Parainfluenza Virus 4</li>
                                <li className='pb-1'>Respiratory Syncytial<br/> virus</li>
                            </ul>
                        </div>
                    </Col>
                    <Col xs='12' sm='12' md='12' lg='4' className=''>
                        <div className='bg-im h-430' style={{ backgroundImage:'url("pathogen-testing/RPP-Testing-bg1.png")', backgroundSize:'contain', height:'', width:'100%', backgroundRepeat:'no-repeat', paddingLeft:'2rem', paddingTop:'3rem'}}>
                        <div className='pb-3 '>
                        <div className='fs-ss-20 text-montserrat fw-700 text-white' style={{ letterSpacing:'0.5px'}}>
                            Bacteria:
                        </div>
                        </div>
                            <ul className='fs-ss-15-2 text-montserrat fw-600 text-white ps-4' style={{ letterSpacing:'0.5px'}}>
                                <li className='pb-1'>Bordetella parapertussis</li>
                                <li className='pb-1'>Bordetella pertussis</li>
                                <li className='pb-1'>Chlamydia pneumoniae</li>
                                <li className='pb-1'>Mycoplasma</li>
                                <li className='pb-1'>Pneumonia</li>
                                <li className='pb-1'>H1, H3 and H1-2009</li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
  )
}

export default PathogenEasyAccess